(function () {
    'use strict';

    angular.module("imApp").factory("selectCustomerService", [function () {
        let service = {};

        return service;
    }]);
})();
